const BASE = import.meta.env.VITE_API_URL || ''
const MIGRATION_KEY = 'softly-default-user-migrated'

export async function migrateDefaultUser(newUserId) {
  if (localStorage.getItem(MIGRATION_KEY)) return
  try {
    const res = await fetch(`${BASE}/api/auth/migrate-default-user`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ newUserId }),
    })
    if (res.ok) {
      localStorage.setItem(MIGRATION_KEY, 'true')
      console.log('[migrate] Default user data migrated to real account')
    }
  } catch (e) {
    console.warn('[migrate] Default user migration failed', e)
  }
}
